import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const HoverCycleImage = ({ images, slug, alt, className, style }) => {
  const [idx, setIdx] = useState(0);
  const intervalRef = useRef(null);
  const navigate = useNavigate();
  const isTouchRef = useRef(false);

  useEffect(() => {
    isTouchRef.current = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
  }, []);

  const startCycle = () => {
    if (isTouchRef.current) return;
    intervalRef.current = setInterval(() => {
      setIdx((prev) => (prev + 1) % images.length);
    }, 1100);
  };

  const stopCycle = () => {
    if (intervalRef.current) { clearInterval(intervalRef.current); intervalRef.current = null; }
    if (!isTouchRef.current) setIdx(0);
  };

  const handleClick = (e) => {
    if (isTouchRef.current) {
      e.preventDefault();
      e.stopPropagation();
      setIdx((prev) => (prev + 1) % images.length);
    } else if (slug) {
      navigate(`/products/${slug}`);
    }
  };

  return (
    <div
      className="relative cursor-pointer w-full h-full"
      onMouseEnter={startCycle}
      onMouseLeave={stopCycle}
      onClick={handleClick}
      data-testid="hover-cycle-image"
    >
      <img src={images[idx]} alt={alt} className={className} style={style} />
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5 z-10">
        {images.map((_, i) => (
          <span
            key={i}
            className="w-2 h-2 rounded-full transition-all duration-300"
            style={{
              background: i === idx ? "#F5C800" : "rgba(255,255,255,0.5)",
              transform: i === idx ? "scale(1.3)" : "scale(1)",
              boxShadow: i === idx ? "0 0 4px rgba(245,200,0,0.5)" : "none",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default HoverCycleImage;
